import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_029.jpg';
page.images = [
  {
    imageId: 'page029_zoom0',
    rectangle: {
      x: 606,
      y: 1210,
      width: 1185,
      height: 884,
    },
    imageSrc: 'images/page029/029 2.jpg',
  },
  {
    imageId: 'page029_zoom1',
    rectangle: {
      x: 602,
      y: 334,
      width: 1188,
      height: 814,
    },
    imageSrc: 'images/page029/029 1.jpg',
  },
];
page.games = [
  {
    id: 'page029_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1189,
    },
    item: {
      id: 'page029_game11',
    },
    rectangle: {
      id: 'page029_rect1',
    },
  },
  {
    id: 'page029_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 269,
    },
    item: {
      id: 'page029_game10',
    },
    rectangle: {
      id: 'page029_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page029_rect0',

    tooltip: '',

    linked: ['page029_game10'],
    x: 127,
    y: 269,
    width: 462,
    height: 600,
  },
  {
    id: 'page029_rect1',

    tooltip: '',

    linked: ['page029_game11'],
    x: 122,
    y: 1189,
    width: 458,
    height: 938,
  },
];
export default page;
